import React from 'react';
import Vehicles from './Vehicles';

const VehiclesWrapper = (props) => (
  <Vehicles {...props} />
);

export default VehiclesWrapper;
